import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'grid-card',
  templateUrl: './grid-card.component.html',
  styleUrls: ['./grid-card.component.scss']
})
export class GridCardComponent implements OnInit {
  @Input() isEditing: boolean;
  @Input() saveDisabled: boolean;
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  constructor() {
    //this is kept empty on purpose
   }

  ngOnInit() {
    //this is kept empty on purpose
  }

  onEdit = () => this.edit.emit();
  onCancel = () => this.cancel.emit();
  onSave = () => this.save.emit();

}
